<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Logo</label>
          <div class="group-item">
            <UploadImage
              @callback="handleUploadLogo"
              :image="{ imageSrc: fields.logo.src }"
              :height="`100`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveLogo"
            />
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Rating</label>
          <div class="group-item">
            <p class="mb-2 font-weight-bold">Avatars Image</p>
            <UploadImage
              @callback="handleUploadAvatars"
              :image="{ imageSrc: fields.rating.avatarsImage }"
              :height="`80`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveAvatars"
            />
            <p class="mb-2 mt-4 font-weight-bold">Stars Image</p>
            <UploadImage
              @callback="handleUploadStars"
              :image="{ imageSrc: fields.rating.starsImage }"
              :height="`80`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveStars"
            />
            <v-text-field v-model="fields.rating.text" class="mt-4" label="Rating Text" hide-details />
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'fastvaluedeal-cta-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ButtonPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: {
        title: 'Fastvaluedeal CTA',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#000000',
          textColor: '#FFFFFF',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        logo: {
          src: '',
        },
        rating: {
          avatarsImage: '',
          starsImage: '',
          text: '4.7 Average Rating',
        },
        button: {
          show: true,
          backgroundColor: '#17BE4F',
          color: '#FFFFFF',
          radius: 8,
          text: 'GET 80% DISCOUNT',
          link: '#',
          iconPrefix: {
            show: false,
            src: '',
          },
          iconSuffix: {
            show: false,
            src: 'false',
          },
          subBtn: {
            show: false,
            text: '',
          },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        logo: { ...this.fields.logo, ...(extract.logo || {}) },
        rating: { ...this.fields.rating, ...(extract.rating || {}) },
        button: {
          ...this.fields.button,
          ...(extract.button || {}),
          iconPrefix: { ...this.fields.button.iconPrefix, ...((extract.button || {}).iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...((extract.button || {}).iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...((extract.button || {}).subBtn || {}) },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
      };
      const updateHtml = updateHtmlFromData.sectionFastvaluedealCta(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadLogo(obj) {
      this.fields.logo.src = (obj && obj.imageSrc) || '';
    },
    handleRemoveLogo() {
      this.fields.logo.src = '';
    },
    handleUploadAvatars(obj) {
      this.fields.rating.avatarsImage = (obj && obj.imageSrc) || '';
    },
    handleRemoveAvatars() {
      this.fields.rating.avatarsImage = '';
    },
    handleUploadStars(obj) {
      this.fields.rating.starsImage = (obj && obj.imageSrc) || '';
    },
    handleRemoveStars() {
      this.fields.rating.starsImage = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
